import React from 'react';

const Heure = (props) => (
    <>
        {props.heureOuverture} {props.heureFermeture}
    </>
)

export default Heure